module.exports = __webpack_public_path__ + "static/media/map-pin-white-dot-small.58cc042c.svg";